export enum SerieEnum {
  Unique = 1,
  Many = 2,
}
